import { render, staticRenderFns } from "./SwiperBtn.vue?vue&type=template&id=30f5b07b&scoped=true"
import script from "./SwiperBtn.vue?vue&type=script&lang=ts"
export * from "./SwiperBtn.vue?vue&type=script&lang=ts"
import style0 from "./SwiperBtn.vue?vue&type=style&index=0&id=30f5b07b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f5b07b",
  null
  
)

export default component.exports